export default "__VITE_ASSET__e543160e__"